<ng-template #rejectParcelTemplate>
    <div class="dialog-outer">
        <div class="dialog-content">
            <div class="header" mat-dialog-title>
                {{'businessTexts.reject' | translate}}
                <button mat-dialog-close class="close-btn" (click)="closeDialog()"
                    matTooltip="{{'businessTexts.close' | translate}}">
                    <cqes-icon icon="close" class="close-icon"></cqes-icon>
                </button>
            </div>
            <mat-dialog-content class="mat-typography con">
                <div class="row-container">

                    <div class="info-container">
                        <!-- Parcel title -->
                        <div class="word-break"><span class="label">{{'businessTexts.packageName' | translate}}:</span>
                            {{parcel.packageName}}
                        </div>

                        <!-- Date -->
                        <div><span class="label">
                            {{'businessTexts.sentOn' | translate}}:</span> {{parcel.date | date: dateFormat}} {{getTimeAbbr()}}
                        </div>
                
                        <!-- signCountTxt -->
                        <div class="word-break"><span class="label">{{'historyTexts.signCount' | translate}}:</span>
                            {{parcel.signCountTxt}}
                        </div>
                    </div>
                    <mat-form-field appearance="fill" class="rejectReason" required>
                        <mat-label>{{'businessTexts.rejectReason' | translate}}</mat-label>
                        <input #rejectReasonModel="ngModel" matInput required pattern=".*\S.*" ngModel [ngModelOptions]="{standalone: true}">
                        <mat-error *ngIf="rejectReasonModel.invalid && (rejectReasonModel.dirty || rejectReasonModel.touched)">{{'businessTexts.reasonRequired' | translate}}</mat-error>
                    </mat-form-field>
                </div>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                    <button mat-button mat-dialog-close class="mat-mdc-raised-button">
                        {{'businessTexts.close' | translate}}
                    </button>
                    <button [disabled]="(rejectReasonModel.value || '').trim().length === 0" mat-button class="mat-mdc-raised-button" color="primary"
                        matTooltip="{{'businessTexts.reject' | translate}}" (click)="onRejectPackage(rejectReasonModel.value)">
                        {{'businessTexts.reject' | translate}}
                    </button>
              </mat-dialog-actions>
        </div>
    </div>
  </ng-template>
<div autofocus class="search-contents">
    <div>
        <!-- Type -->
        <mat-form-field>
            <mat-select placeholder="{{'historyTexts.type' | translate}}" [(ngModel)]="displayOptions.parcelType"
                (selectionChange)="setParcelType()">
                <mat-option *ngFor="let optionData of parcelTypeOptions" [value]="optionData.type">
                    {{optionData.textToVisualize | async}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Status -->
        <mat-form-field>
            <mat-select placeholder="{{'historyTexts.orderStatus' | translate}}" [(ngModel)]="displayOptions.status"
                (selectionChange)="setOrderStatus()">
                <mat-option *ngFor="let optionData of statusesAndLabelsForParcel" [value]="optionData.status">
                    {{optionData.textToVisualize | async}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Search by name -->
        <mat-form-field class="search-container">
            <input class="search-input" matInput placeholder="{{'businessTexts.packageName' | translate}}"
                [(ngModel)]="displayOptions.textToShow" (keydown.enter)="searchRequestedPackage()">
            <button *ngIf="displayOptions.textToShow" class="close-button" matSuffix mat-icon-button [attr.aria-label]="'common.clear' | translate"
                (click)="clearText()">
                <cqes-icon icon="close">
                </cqes-icon>
            </button>
        </mat-form-field>

        <!-- Start date -->
        <mat-form-field>
            <input matInput [matDatepicker]="startDate" placeholder="{{'historyTexts.startDate' | translate}}"
                [(ngModel)]="fromDate" (ngModelChange)="setRequestDates()" [max]="maxStartDateValue">
            <mat-datepicker-toggle matSuffix [for]="startDate">
                <cqes-icon icon="calendar_today" class="calendar-icon">
                </cqes-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
        </mat-form-field>

        <!-- End date -->
        <mat-form-field>
            <input matInput [matDatepicker]="endDate" placeholder="{{'historyTexts.endDate' | translate}}"
                [(ngModel)]="toDate" (ngModelChange)="setRequestDates()" [min]="minEndDateValue">
            <mat-datepicker-toggle matSuffix [for]="endDate">
                <cqes-icon icon="calendar_today" class="calendar-icon">
                </cqes-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
        </mat-form-field>

        <!-- Получател -->
        <mat-form-field class="search-container">
            <input matInput [(ngModel)]="displayOptions.recipient" name="recipient"
                (keydown.enter)="searchRequestedPackage()" placeholder="{{'businessTexts.recipient' | translate}}">
            <button *ngIf="displayOptions.recipient" matSuffix mat-icon-button [attr.aria-label]="'common.clear' | translate"
                (click)="displayOptions.recipient=''">
                <cqes-icon icon="close"></cqes-icon>
            </button>
        </mat-form-field>

        <!-- Изпращач -->
        <div [ngClass]="this.isSuperAdmin ? 'show': 'hide'">
            <mat-form-field class="search-container">
                <input matInput [(ngModel)]="displayOptions.sender" placeholder="{{'businessTexts.sender' | translate}}"
                    name="sender" (keydown.enter)="searchRequestedPackage()">
                <button *ngIf="displayOptions.sender" matSuffix mat-icon-button [attr.aria-label]="'common.clear' | translate"
                    (click)="displayOptions.sender=''">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
    <div class="row-content-right">
 
        <button class="mat-mdc-raised-button action-button" (click)="resetFilters()">
            {{'historyTexts.resetFilters' | translate}}
        </button>
        <button class="mat-mdc-raised-button action-button" (click)="searchRequestedPackage()">
            {{'historyTexts.searchIntoSignDocs'
            | translate}}
        </button>
    </div>
</div>

<cloud-history-table-spinner *ngIf="isLoading" />

<div class="no-content-message" *ngIf="!hasData() && !isLoading">
    {{'historyTexts.noDocumentsFound' | translate}}
</div>

<div class="data-container" [hidden]="!hasData() || isLoading">

    <div class="mat-elevation-z8 table-content">
        <mat-table [dataSource]="signingHistoryDataSource" matSort matSortActive="date" matSortDirection="desc">
            <ng-container matColumnDef="status">
                <mat-header-cell class="d-none d-sm-flex" *matHeaderCellDef>
                    {{'historyTexts.documentStatus' | translate}} </mat-header-cell>
                <mat-cell class="tac d-none d-sm-flex" *matCellDef="let row"
                    matTooltip="{{(row.statusIcon)?.tooltip | translate}}">
                    <cqes-icon [icon]="row.statusIcon?.icon" [iconClass]="row.statusIcon?.colorClass"></cqes-icon>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
                <mat-header-cell class="d-none d-sm-flex" *matHeaderCellDef>
                    {{'historyTexts.type' | translate}} </mat-header-cell>
                <mat-cell class="tac d-none d-sm-flex" *matCellDef="let row"
                    matTooltip="{{(row.typeIcon)?.tooltip | translate}}">
                    <cqes-icon [icon]="row.typeIcon?.icon"></cqes-icon>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="signCountTxt">
                <mat-header-cell #signCountTxt class="d-block d-sm-flex" *matHeaderCellDef>
                    {{'historyTexts.signCount' | translate}} </mat-header-cell>
                <mat-cell class="d-block d-sm-flex" *matCellDef="let row"> {{row.signCountTxt}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="date">
                <mat-header-cell #date class="d-block d-sm-flex" *matHeaderCellDef mat-sort-header
                    (click)="sortByHeader(date)">
                    {{'businessTexts.sentDate' | translate}}
                </mat-header-cell>
                <mat-cell class="d-block d-sm-flex" *matCellDef="let row">
                    {{row.date | date: dateFormat}}<br>{{row.date | date: timeFormat}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="downloadeTimestamp">
                <mat-header-cell #downloadeTimestamp class="d-block d-sm-flex" *matHeaderCellDef mat-sort-header
                    (click)="sortByHeader(downloadeTimestamp)">
                    {{'historyTexts.downloadeTimestampDate' | translate}}
                </mat-header-cell>
                <mat-cell class="d-block d-sm-flex" *matCellDef="let row">
                    {{row.downloadeTimestamp | date: dateFormat}}<br>{{row.downloadeTimestamp | date: timeFormat}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="packageName">
                <mat-header-cell #packageName class="d-block d-lg-flex" *matHeaderCellDef mat-sort-header
                    (click)="sortByHeader(packageName)">
                    {{'businessTexts.packageName'
                    | translate}} </mat-header-cell>
                <mat-cell class="d-block d-lg-flex truncate" *matCellDef="let row" #el
                    (mouseenter)="updatePackageNameTooltip(row, el)"
                    (mouseleave)="row.packageNameTooltip = ''"
                    [matTooltip]="row.packageNameTooltip"
                    [matTooltipDisabled]="!row.packageNameTooltip"> {{row.packageName}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="documentsCount">
                <mat-header-cell #documentsCount class="d-block d-sm-flex" *matHeaderCellDef>
                    {{'businessTexts.documentsCount'
                    | translate}} </mat-header-cell>
                <mat-cell class="d-block d-lg-flex" *matCellDef="let row"> {{row.docCount}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
                <mat-header-cell #downloadDocument class="d-sm-flex" *matHeaderCellDef>
                    {{'historyTexts.actions' | translate}}</mat-header-cell>
                <mat-cell class="d-sm-flex" *matCellDef="let row">
                    <div>
                        <span [matMenuTriggerFor]="actionsMenu">
                            <button mat-icon-button color="primary">
                                <cqes-icon icon="menu"></cqes-icon>
                            </button>
                        </span>
                        <mat-menu #actionsMenu [overlapTrigger]="false" class="nav-responsive-overlay menu">

                            <button [hidden]="isSubcomponent" mat-menu-item color="primary"
                                (click)="openRequestedDetailsDialog(row)">
                                <cqes-icon icon="info_outline"></cqes-icon>
                                {{'businessTexts.details' | translate}}
                            </button>

                            <button *ngIf="row.isDownloadable" mat-menu-item
                                matTooltip="{{'businessTexts.downloadParcel' | translate}}"
                                (click)="onDownloadPackage(row)">
                                <cqes-icon icon="file_download"></cqes-icon>
                                {{(row.isRegisteredMail ? 'historyTexts.downloadRegisteredMail':
                                'businessTexts.downloadParcel') | translate}}
                            </button>

                            <button *ngIf="row.isResendable" mat-menu-item color="primary"
                                matTooltip="{{'businessTexts.resend' | translate}}" (click)="onResendPackage(row)">
                                <cqes-icon icon="mail"></cqes-icon>
                                {{'businessTexts.resend' | translate}}
                            </button>

                            <button *ngIf="row.isRejectable" mat-menu-item color="primary"
                                matTooltip="{{'businessTexts.reject' | translate}}"
                                (click)="openParcelRejectDialog(row)">
                                <cqes-icon icon="close"></cqes-icon>
                                {{'businessTexts.reject' | translate}}
                            </button>

                            <button *ngIf="row.isRegisteredMailReceiptDownloadable" mat-menu-item color="primary"
                                matTooltip="{{'businessTexts.downloadRegisteredMailReceipt' | translate}}"
                                (click)="onDownloadRegisteredMailReceipt(row)">
                                <cqes-icon icon="system_update_alt"></cqes-icon>
                                {{'businessTexts.downloadRegisteredMailReceipt' | translate}}
                            </button>

                        </mat-menu>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator [pageSize]="tableHelper.pageSize" [pageSizeOptions]="tableHelper.pageSizeOptions"
            (page)="onPaginateChange($event)">
        </mat-paginator>
    </div>


</div>